import { render } from "./EnBanner.vue?vue&type=template&id=5314408f&ts=true"
import script from "./EnBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnBanner.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/alert/EnBanner/EnBanner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5314408f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5314408f', __exports__)) {
    api.reload('5314408f', __exports__)
  }
  
  module.hot.accept("./EnBanner.vue?vue&type=template&id=5314408f&ts=true", () => {
    api.rerender('5314408f', render)
  })

}


export default __exports__